import { render, staticRenderFns } from "./DetailsProgress.vue?vue&type=template&id=46d487e7&scoped=true"
import script from "./DetailsProgress.vue?vue&type=script&lang=js"
export * from "./DetailsProgress.vue?vue&type=script&lang=js"
import style0 from "./DetailsProgress.vue?vue&type=style&index=0&id=46d487e7&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d487e7",
  null
  
)

export default component.exports